import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { sortBy } from 'lodash';
import { Subscription } from 'rxjs';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { TicketMessageType } from '../enums/ticket-message-type.enum';
import { TicketEmailHistory } from '../interface/ticket-email-history.interface';
import { CustomerService } from '../services/customer.service';
import { NotificationType } from '../enums/notification-types.enum';
import { saveAs as importedSaveAs } from 'file-saver';

@Component({
    selector: 'app-ticket-email-history',
    templateUrl: '../templates/template1/views/ticket-email-history.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/ticket.less','../templates/template1/themes/default/css/my-team-tickets.component.less'
    ]
})
export class TicketEmailHistoryComponent implements OnInit, OnDestroy {
    @Input() ticketID: number;
    ticketMessageHistory: TicketEmailHistory[];
    ticketMessageType = TicketMessageType;
    emailHistorySubscription: Subscription;
    constructor(
        private _customerservice: CustomerService,
        private _messageService: MessageService,
        private _translatePipe: TranslateService,
        private _commonService: CommonService,

    ) {
    }
    ngOnInit(): void {
        this.getTicketEmailHistory();
        this.subscribeTicketEmailHistory();
    }
    /**
     * @description getting Ticket Email History
     * @date 2019-10-30
     * @memberof TicketEmailHistory
     */
    getTicketEmailHistory() {
        if (this.ticketID) {
            this.ticketMessageHistory = [];
            this._customerservice.getTickeEmailHistoryByTicketId(this.ticketID)
                .subscribe(response => {
                    if (response && response.success) {
                        response.messages.forEach(message => {
                            if (message.attachments && message.attachments.length) {
                                if (message.typeId === TicketMessageType.INCOMINGMAIL) {
                                    message.attachments.forEach(item => {
                                        item.url = ApiUrlConstants.customerServiceApiUrl + 'download?key=' + item.url
                                            + '&fileName=' + item.fileName;
                                    });
                                }
                                message.attachments = sortBy(message.attachments, 'fileName');
                                  }
                                  if (message.mailBody && message.mailBody.indexOf('<a href') > -1
                                && message.mailBody.indexOf('target=_blank') === -1 ) {
                                    message.mailBody = message.mailBody.replace(/href=/g, ' target=_blank href=');
                            }
                        });
                        this.ticketMessageHistory =  response.messages;
                    }
                });
        }
    }
   /**
    * updating Email History after send draft mail
    */
    subscribeTicketEmailHistory() {
        this.emailHistorySubscription = this._messageService.getDraftEmailsaved().subscribe(response => {
            this.getTicketEmailHistory();
        });
    }

    downloadDocument(url: string, fileName: string,messagetypeId: number) {
      if(messagetypeId === TicketMessageType.INCOMINGMAIL) {
        this._customerservice.getIncomingAttachment(url).subscribe(blob => {
          importedSaveAs(blob, fileName);
          const notification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
        }, err => {
          let downloadNotification: any = this._translatePipe.get("Something Went Wrong, Please try again after some time");
          this._commonService.createNotification("", downloadNotification.value, NotificationType.ERROR);
        });
      } else {
        let path = new URL(url).pathname.slice(1);
        let s3Path = path.slice(0, path.lastIndexOf("/") + 1);
        this._customerservice.downloadFile(s3Path, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          const notification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
        }, err => {
          let downloadNotification: any = this._translatePipe.get("Something Went Wrong, Please try again after some time");
          this._commonService.createNotification("", downloadNotification.value, NotificationType.ERROR);
        });
      }
    }

    /**
     * unsubscribe
     */
    ngOnDestroy() {
        if (this.emailHistorySubscription) {
            this.emailHistorySubscription.unsubscribe();
        }
    }

}





// WEBPACK FOOTER //
// ./src/app/customerservice/components/ticket-email-history.component.ts